export type VideoVariant = "main" | "fallback";

export interface VariantAttempt {
  current(): VideoVariant;
  select(variant: VideoVariant): void;
  alternateAfterFailure(): VideoVariant | null;
}

export function createVariantAttempt(initial: VideoVariant = "fallback"): VariantAttempt {
  let current = initial;
  let attempted = new Set<VideoVariant>([initial]);
  return {
    current: () => current,
    select: variant => {
      current = variant;
      attempted = new Set([variant]);
    },
    alternateAfterFailure: () => {
      const alternate = current === "fallback" ? "main" : "fallback";
      if (attempted.has(alternate)) return null;
      attempted.add(alternate);
      current = alternate;
      return alternate;
    },
  };
}

export function variantOptions(): Array<{ value: VideoVariant; label: string }> {
  return [
    { value: "fallback", label: "Fallback" },
    { value: "main", label: "Main" },
  ];
}

export function findPreferredAudioTrack<T extends { locale: string | null }>(
  tracks: readonly T[],
  preferredLocale: string | null,
): T | null {
  if (!preferredLocale) return null;
  const normalized = preferredLocale.toLocaleLowerCase();
  return tracks.find(track => track.locale?.toLocaleLowerCase() === normalized) ?? null;
}
